// extracted by mini-css-extract-plugin
module.exports = {"wrap":"we","subtitle":"xe","contentWrap":"ye","imgWrap":"ze","heading":"Ae","copy":"Be"};